module.exports = __webpack_public_path__ + "img/seccion1.2.b11ccbf6.png";